import { type MutableRefObject, useEffect, useRef } from 'react';
import { type BarcodeOrgInfo, useOrganizationGs1Prefix } from 'src/modules/palletTags';

/**
 * The GS1 prefix the editor's barcode blocks render with. GrapesJS registers the plugin once, so it
 * reads a ref at render time; the ref follows the cache-only settings read (0 requests of its own).
 */
export function useBarcodeOrgInfoRef(): MutableRefObject<BarcodeOrgInfo> {
  const gs1CompanyPrefix = useOrganizationGs1Prefix();
  const orgInfo = useRef<BarcodeOrgInfo>({ gs1CompanyPrefix });

  useEffect(() => {
    orgInfo.current = { gs1CompanyPrefix };
  }, [gs1CompanyPrefix]);

  return orgInfo;
}
